import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { SiaTooltipDirective, SiaTranslatePipe } from '@sia/shared';
import { SiaBaseEditorSignalComponent } from '../sia-base-editor/sia-base-editor-signal.component';
import { SiaEmailButtonComponent } from '../sia-email-button/sia-email-button.component';
import { SiaErrorHintComponent } from '../sia-error-hint/sia-error-hint.component';

@Component({
  selector: 'sia-email-box',
  templateUrl: './sia-email-box.component.html',
  styleUrls: ['./sia-email-box.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    SiaTooltipDirective,
    MatHint,
    SiaErrorHintComponent,
    SiaEmailButtonComponent,
    SiaTranslatePipe,
  ],
})
export class SiaEmailBoxComponent extends SiaBaseEditorSignalComponent {
  @HostListener('window:unload')
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
